export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-export-8ead465191d3c53d003038035953ce69.svg";